import { render, staticRenderFns } from "./ord_tmpl.vue?vue&type=template&id=797c9306&scoped=true"
import script from "./ord_tmpl.vue?vue&type=script&lang=js"
export * from "./ord_tmpl.vue?vue&type=script&lang=js"
import style0 from "./ord_tmpl.vue?vue&type=style&index=0&id=797c9306&prod&scoped=true&lang=less"
import style1 from "./ord_tmpl.vue?vue&type=style&index=1&id=797c9306&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797c9306",
  null
  
)

export default component.exports